import { deActivity, deEnum, deError as deSharedError, enActivity, enEnum, enError as enSharedError } from "@finway-group/shared/lib/locales"
import { UserLanguageEnum } from "@finway-group/shared/lib/models/user/userSettings.interface"
import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import deAction from "~Shared/locales/de/action.json"
import deAppend from "~Shared/locales/de/append.json"
import deConfirm from "~Shared/locales/de/confirm.json"
import deConjunction from "~Shared/locales/de/conjunction.json"
import deCorporate from "~Shared/locales/de/corporate.json"
import deCreditCard from "~Shared/locales/de/creditCard.json"
import deDeliveryNote from "~Shared/locales/de/deliveryNote.json"
import deError from "~Shared/locales/de/error.json"
import deHelp from "~Shared/locales/de/help.json"
import deInfo from "~Shared/locales/de/info.json"
import deInput from "~Shared/locales/de/input.json"
import deLabel from "~Shared/locales/de/label.json"
import deMissing from "~Shared/locales/de/missing.json"
import deNav from "~Shared/locales/de/nav.json"
import deNotification from "~Shared/locales/de/notification.json"
import dePlaceholder from "~Shared/locales/de/placeholder.json"
import dePurchaseOrder from "~Shared/locales/de/purchaseOrder.json"
import deTooltips from "~Shared/locales/de/tooltips.json"
import deValidation from "~Shared/locales/de/validation.json"
import deView from "~Shared/locales/de/view.json"
import enAction from "~Shared/locales/en/action.json"
import enAppend from "~Shared/locales/en/append.json"
import enConfirm from "~Shared/locales/en/confirm.json"
import enConjunction from "~Shared/locales/en/conjunction.json"
import enCorporate from "~Shared/locales/en/corporate.json"
import enCreditCard from "~Shared/locales/en/creditCard.json"
import enDeliveryNote from "~Shared/locales/en/deliveryNote.json"
import enError from "~Shared/locales/en/error.json"
import enHelp from "~Shared/locales/en/help.json"
import enInfo from "~Shared/locales/en/info.json"
import enInput from "~Shared/locales/en/input.json"
import enLabel from "~Shared/locales/en/label.json"
import enMissing from "~Shared/locales/en/missing.json"
import enNav from "~Shared/locales/en/nav.json"
import enNotification from "~Shared/locales/en/notification.json"
import enPlaceholder from "~Shared/locales/en/placeholder.json"
import enPurchaseOrder from "~Shared/locales/en/purchaseOrder.json"
import envTooltips from "~Shared/locales/en/tooltips.json"
import enValidation from "~Shared/locales/en/validation.json"
import enView from "~Shared/locales/en/view.json"
import { isNodeEnvTest } from "~Shared/utils/helper.utils"

const resources = {
    en: {
        nav: enNav,
        action: enAction,
        validation: enValidation,
        input: enInput,
        placeholder: enPlaceholder,
        tooltips: envTooltips,
        error: { ...enError, ...enSharedError },
        view: enView,
        label: enLabel,
        append: enAppend,
        notification: enNotification,
        confirm: enConfirm,
        conjunction: enConjunction,
        info: enInfo,
        missing: enMissing,
        help: enHelp,
        activity: enActivity,
        enum: enEnum,
        creditCard: enCreditCard,
        corporate: enCorporate,
        purchaseOrders: enPurchaseOrder,
        deliveryNote: enDeliveryNote,
    },
    de: {
        nav: deNav,
        action: deAction,
        validation: deValidation,
        input: deInput,
        placeholder: dePlaceholder,
        tooltips: deTooltips,
        error: { ...deError, ...deSharedError },
        view: deView,
        label: deLabel,
        append: deAppend,
        notification: deNotification,
        confirm: deConfirm,
        conjunction: deConjunction,
        info: deInfo,
        missing: deMissing,
        help: deHelp,
        activity: deActivity,
        enum: deEnum,
        creditCard: deCreditCard,
        corporate: deCorporate,
        purchaseOrders: dePurchaseOrder,
        deliveryNote: deDeliveryNote,
    },
}

/*
declare custom type options so the return is always a string. 
reference: https://www.i18next.com/overview/typescript#argument-of-type-defaulttfuncreturn-is-not-assignable-to-parameter-of-type-xyz
*/
declare module "i18next" {
    interface CustomTypeOptions {
        returnNull: false
    }
}

void i18next
    .use(initReactI18next) // bind react-i18next to the instance
    .init({
        react: {
            useSuspense: false,
        },
        resources,
        lng: isNodeEnvTest ? UserLanguageEnum.EN : navigator.language,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        returnNull: false,
    })

i18next.services?.formatter?.add("lowercase", (value) => value.toLowerCase())

export const i18n = i18next
